import { cloneDeep } from 'lodash';

export const state = {
    isUnderSixtyYearsOld: null,
    isUnderTwentyYearsOld: null,
    defaultTemplateModel: null
};

export const actions = {
    setIsUnderSixtyYearsOld({ commit }, payload) {
        commit('setIsUnderSixtyYearsOld', payload);
    },
    setIsUnderTwentyYearsOld({ commit }, payload) {
        commit('setIsUnderTwentyYearsOld', payload);
    }
};

export const mutations = {
    setIsUnderSixtyYearsOld(state, payload) {
        state.isUnderSixtyYearsOld = payload;
    },
    setIsUnderTwentyYearsOld(state, payload) {
        state.isUnderTwentyYearsOld = payload;
    },
    setDefaultTemplateModel(state, payload) {
        state.defaultTemplateModel = cloneDeep(payload);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};